import React from "react";

import {
  cn,
} from "../utils/siteActivityFormatters";

const monitorClasses = {
  checking:
    "bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-200",

  ok:
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-200",

  warning:
    "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200",

  offline:
    "bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-200",

  stats_only:
    "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
};

const productClasses = {
  sky:
    "bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-200",

  cyan:
    "bg-cyan-100 text-cyan-700 dark:bg-cyan-900/40 dark:text-cyan-200",

  violet:
    "bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-200",

  emerald:
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-200",

  amber:
    "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200",

  rose:
    "bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-200",

  slate:
    "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200",
};

export function ApiStatusBadge({
  status = "ok",
  title,
}) {
  const labels = {
    checking:
      "Analyse…",

    ok:
      "Surveillé",

    warning:
      "À vérifier",

    offline:
      "Indisponible",

    stats_only:
      "Stats seules",
  };

  return (
    <span
      title={title}
      className={cn(
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-bold",
        monitorClasses[
          status
        ] ||
          monitorClasses.warning,
      )}
    >
      {labels[status] ||
        "À vérifier"}
    </span>
  );
}

export function ProductBadge({
  label,
  tone = "slate",
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-bold",
        productClasses[
          tone
        ] ||
          productClasses.slate,
      )}
    >
      {label}
    </span>
  );
}